import { combineReducers } from 'redux';
import boomerang from 'src/features/Boomerang/state/reducer';
import {createResponsiveStateReducer} from 'redux-responsive';

export default combineReducers({
  browser: createResponsiveStateReducer({
    extraSmall: 480,
    small: 768,
    medium: 992,
    large: 1280,
    extraLarge: 1400,
  }),
  boomerang,
});
